import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const ContactManagement = lazy(() =>
  import('@repo/ui/features/contact/index').then((mod) => ({ default: mod.ContactManagement })),
);

export default function ContactsPage() {
  return (
    <div className="w-full py-6">
      <Suspense fallback={<DendromapLoader message="Chargement des contacts..." />}>
        <ContactManagement />
      </Suspense>
    </div>
  );
}
